import { jsx, Fragment } from "react/jsx-runtime";
import { memo, useMemo, Fragment as Fragment$1 } from "react";
import katex from "../../node_modules/.pnpm/katex@0.10.2/node_modules/katex/dist/katex.js";
import { normalizeKatexMath } from "../../utils/KatexRenderer.js";
const MATH_PATTERN = /\$\$([^$]+)\$\$/g;
function splitMetadataText(text) {
  const pattern = new RegExp(MATH_PATTERN);
  const parts = [];
  let cursor = 0;
  let match;
  while ((match = pattern.exec(text)) !== null) {
    if (match.index > cursor) parts.push({ text: text.slice(cursor, match.index) });
    parts.push({ text: match[0], math: match[1] });
    cursor = pattern.lastIndex;
  }
  if (cursor < text.length) parts.push({ text: text.slice(cursor) });
  return parts;
}
function hasMetadataMath(text) {
  return typeof text === "string" && new RegExp(MATH_PATTERN).test(text);
}
function splitMetadataConcepts(value) {
  if (!value) return [];
  const concepts = [];
  let current = "";
  for (const part of splitMetadataText(value)) {
    if (part.math !== void 0) {
      current += part.text;
      continue;
    }
    const fragments = part.text.split(",");
    fragments.forEach((fragment, index) => {
      current += fragment;
      if (index < fragments.length - 1) {
        if (current.trim()) concepts.push(current.trim());
        current = "";
      }
    });
  }
  if (current.trim()) concepts.push(current.trim());
  return concepts;
}
const MetadataMath = memo(function MetadataMath2({ math, raw }) {
  const markup = useMemo(() => {
    try {
      return katex.renderToString(normalizeKatexMath(math), {
        throwOnError: false,
        displayMode: false
      });
    } catch {
      return null;
    }
  }, [math]);
  return markup == null ? /* @__PURE__ */ jsx(Fragment, { children: raw }) : /* @__PURE__ */ jsx(
    "span",
    {
      className: "content-metadata-math",
      style: { display: "inline-block", verticalAlign: "baseline", whiteSpace: "nowrap", lineHeight: "normal" },
      dangerouslySetInnerHTML: { __html: markup }
    }
  );
});
function ContentMetadataText({ text, className }) {
  const parts = useMemo(() => splitMetadataText(text ?? ""), [text]);
  if (!text) return null;
  const content = parts.map((part, index) => part.math !== void 0 ? /* @__PURE__ */ jsx(MetadataMath, { math: part.math, raw: part.text }, index) : /* @__PURE__ */ jsx(Fragment$1, { children: part.text }, index));
  return className || parts.some((part) => part.math !== void 0) ? /* @__PURE__ */ jsx("span", { className, children: content }) : /* @__PURE__ */ jsx(Fragment, { children: content });
}
export {
  ContentMetadataText,
  hasMetadataMath,
  splitMetadataConcepts
};
//# sourceMappingURL=ContentMetadataText.js.map
